// ============================================================================
// This file contains global custom code which is specific to this project.
// ============================================================================


// Global Variables.
// ================================================================================================
var dataCategoryAColor,
    dataCategoryBColor,
    dataCategoryCColor,
    dataAlternateColor,
    elPageWrapper;




// Global Functions.
// ================================================================================================

function formatCurrency(value, currencySymbol, numberOfDigits) {
  var locale = 'en-US';

  var currencyOptions = {
    style: 'currency',
    currency: 'USD',
    useGrouping: true,
    minimumFractionDigits: numberOfDigits,
    maximumFractionDigits: numberOfDigits
  };
  var currencyFormat = new Intl.NumberFormat(locale, currencyOptions);
  var usdFormatValue = currencyFormat.format(value);
  return usdFormatValue.replace("$", currencySymbol);
}

function formatDate(date) {
  return date.toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'
}

function isNumber(value) {
  return typeof value === 'number' && isFinite(value);
}

function amountFormatterWithCents(data) {
  return amountFormatter(data, 2);
}

function amountFormatterWithoutCents(data) {
  return amountFormatter(data, 0);
}

function amountFormatter(data, numberOfDigits) {
  if (data === null || data === undefined) {
    return null;
  }

  if (isNumber(data) || data.length > 0) {
    return formatCurrency(data, currencySymbol, numberOfDigits);
  }

  return '';
}

function amountFooterFormatterWithCents(data) {
  var field = this.field;
  return amountFooterFormatter(data, field, 2);
}

function amountFooterFormatterWithoutCents(data) {
  var field = this.field;
  return amountFooterFormatter(data, field, 0);
}

function amountFooterFormatter(data, field, numberOfDigits) {
  var total = 0;

  if (data.length > 0) {
    total = data.reduce(function (sum, row) {
      return sum + (+row[field]);
    }, 0);

    return formatCurrency(total, currencySymbol, numberOfDigits);
  }

  return '';
}

// Returns the value of the specified CSS variable.
function getCssValue(cssVariable) {
    return getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
}

// Returns the value in parameter or defaultValue if value is 'undefined'
function setDefaultVal(value, defaultValue){
   return (value === undefined) ? defaultValue : value;
}


// Returns the available height (in pixels) for the main content in the page (without topbar, header, etc.)
function getAvailableHeight() {
    var windowHeight = window.innerHeight;
    var topbarHeight = setDefaultVal($(".topbar").outerHeight(true), 0);
    var titleHeight = setDefaultVal($(".page-titles").outerHeight(true), 0);

    return windowHeight - topbarHeight - titleHeight;
}


// Returns the width of the main section of the app.
function getContentSectionWidth() {
  var pageWrapperWidth = elPageWrapper.innerWidth();
  return pageWrapperWidth;
}


// Sets a custom width class to the page-wrapper element, depending on the content section's width (without sidebar).
// This class is used like a media query in the CSS and allow for style adjustments depending on the real space
// available for the content.
function setPageWidthClass() {
  var contentSectionWidth = getContentSectionWidth();
  //console.log(contentSectionWidth);
  elPageWrapper.removeClass("xxlarge xlarge large medium small xsmall");

  if (contentSectionWidth > 1500) {
    elPageWrapper.addClass("xxlarge");
  } else if (contentSectionWidth > 1200) {
    elPageWrapper.addClass("xlarge");
  } else if (contentSectionWidth > 1000) {
    elPageWrapper.addClass("large");
  } else if (contentSectionWidth > 800) {
    elPageWrapper.addClass("medium");
  } else if (contentSectionWidth > 560) {
    elPageWrapper.addClass("small");
  } else {
    elPageWrapper.addClass("xsmall");
  }
}


// Redirects the page to the specified URL.
function doRedirect(url) {
  if (url && url.indexOf('http') == 0) {
    const urlObj = new URL(url);
    // Doesn't redirect if the url hasn't changed if we don't add this timestamp parameter.
    urlObj.searchParams.set('_', new Date().getTime());
    window.location.href = urlObj.toString();
    return true;
  }
}



// Component initialization and configuration.
// ================================================================================================

$(document).ready(function () {

    // When no org is selected, display a modal with the select from the page replicated.
    // Choosing one replicate the choice in the page select and trigger the submit event
    let orgFormSelect = $('#organizationFormSelect');
    if (orgFormSelect.length > 0 && orgFormSelect.find('[selected=""]').text() === "") {
      $('#choose-org-reminder-modal').modal('show');
      $('#modalOrganizationFormSelect').change(function(){
        let selectedOption = $('#modalOrganizationFormSelect').find(":selected").val();
        $('#organizationFormSelect').val(selectedOption).change();
      });
    }

    // Setting chart color codes (from main CSS file) for use into JS code.
    dataCategoryAColor = getCssValue("--data-category-a-color");
    dataCategoryBColor = getCssValue("--data-category-b-color");
    dataCategoryCColor = getCssValue("--data-category-c-color");
    dataAlternateColor = getCssValue("--data-alternate-color");

    elPageWrapper = $(".page-wrapper").first();

    // Back button behavior (browser history)
    $("a.back").on('click', function(e){
        e.preventDefault();
        window.history.back();
        return false;
    });


    // Show toast on page load.
    $('.toast-context').toast({
        animation: true,
        delay: notificationDismissDelay
    });
    $('.toast-context').toast('show');

    // We open the user-menu dropdown manually because if we use data-toggle="dropdown" the selectpicker in it is not working
    $('#user-menu-button').on('click', function (event) {
        $(this).parent().toggleClass('open show');
    });

    // We need to handle the click outside the dropdown to close it manually since we don't use data-toggle="dropdown"
    $('body').on('click', function (e) {
      if (!$('#user-dropdown').is(e.target) && $('#user-dropdown').has(e.target).length === 0 && $('.open').has(e.target).length === 0) {
        $('#user-dropdown').removeClass('open show');
      }
    });

    // Handling the group selection.
    //https://developer.snapappointments.com/bootstrap-select/options/#core-options
    $("#groupForm .selectpicker").first().on('change', function(e) {
      var parentForm = $(this).parents('form').first();
      parentForm.submit();
    });

    // Handling the organization selection.
    //https://developer.snapappointments.com/bootstrap-select/options/#core-options
    $("#organizationForm .selectpicker").first().on('change', function(e) {
      var parentForm = $(this).parents('form').first();
      parentForm.submit();
    });

    // Handling the language selection.
    //https://developer.snapappointments.com/bootstrap-select/options/#core-options
    $("#languageForm .selectpicker").first().on('change', function(e) {
      var parentForm = $(this).parents('form').first();
      parentForm.submit();
    });

    // Handling the impersonification user's selection.
    //https://developer.snapappointments.com/bootstrap-select/options/#core-options
    $("#impersonificationForm .selectpicker").first().on('change', function(e) {
      var parentForm = $(this).parents('form').first();
      parentForm.submit();
    });

    // Replace all SVG images (integrated using an <img> tag) with inline SVG
    // for CSS styling purposes.
    jQuery('img.svg').each(function(){
        var $img = jQuery(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        jQuery.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data).find('svg');

            // Add replaced image's ID to the new SVG
            if(typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if(typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass+' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
            if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
            }

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');

    });


    // Global Window 'resize' event handler.
    $(window).on("resize", function() {
      setPageWidthClass();
    });

    setPageWidthClass();
});

// This function allows to check if an HTML form is valid
$.fn.isValid = function() {
    var isValid = true;
    this.each(function() {
        if(this.checkValidity()==false) {
            isValid = false;
        }
    });

    return isValid;
};

function onColumnSortClick(columnName) {
  let urlParams = new URLSearchParams(window.location.search);
  let currentSort = urlParams.get('sortBy');

  if (currentSort === columnName)
    urlParams.set('sortBy', '-' + columnName);
  else
    urlParams.set('sortBy', columnName);

  window.location.search = urlParams;
}

// This function can be used to sort any table by clicking on the header
// See typical-activities-table.html for an example
function sortTable(tableId, columnId) {
  let currentColId = 0;
  let sortAscending = true;

  // For all the sortable headers
  $('a.header-sort-link').each(function() {
    // Get the inner <i> element
    const iconElement = $(this).find('i');

    let classesToSet = "mdi mdi-unfold-more";

    if (currentColId === columnId) {
      // Get iconElements classes
      let currentClasses = iconElement.attr('class').split(' ');

      if (currentClasses.includes('mdi-chevron-up')) {
        sortAscending = false;
      }

      if (sortAscending)
        classesToSet = "mdi mdi-chevron-up active-sort";
      else
        classesToSet = "mdi mdi-chevron-down active-sort";
    }

    iconElement.removeClass();
    iconElement.addClass(classesToSet);

    currentColId++;
  });

  // Sort the table
  let rows = $("#" + tableId + " tbody tr").detach().get();

  rows.sort(function(row1, row2) {
    let v1, v2, retVal;
    v1 = $(row1).find("td:eq(" + columnId + ")").text();
    v2 = $(row2).find("td:eq(" + columnId + ")").text();

    if (v1 < v2) {
      retVal = -1;
    } else if (v1 > v2) {
      retVal = 1;
    } else {
      retVal = 0;
    }

    if (!sortAscending) {
      retVal = -retVal;
    }

    return retVal;
  });

  $("#" + tableId + " tbody").append(rows);
}

function onSelectChange(elementId, paramName) {
  var selectedValue = document.getElementById(elementId).value;

  var urlParams = new URLSearchParams(window.location.search);
  urlParams.set(paramName, selectedValue);
  window.location.search = urlParams;
}

function onPageChange(pageNumber) {
  let urlParams = new URLSearchParams(window.location.search);
  urlParams.set('page', pageNumber);
  window.location.search = urlParams;
}

const MessageLevel = {
    SUCCESS: 'toast-success',
    INFO: 'toast-info',
    WARNING: 'toast-warning',
    ERROR: 'toast-error'
};

function showToastJs(message, level= MessageLevel.SUCCESS) {
  $('#toast-js-body').html(message);

  let toastElement = $('#toast-js');

  toastElement.attr("class", "toast " + level);
  toastElement.toast({ animation: false, delay: notificationDismissDelay});
  toastElement.toast('show');
}

function validateIfShouldProceedEvenIfChangesMade() {
  let proceed = true;

  if (changeMade) {
    const confirmation = confirm(unsavedChangesMessage);
    if (!confirmation) {
      proceed = false;
    }
    else {
      // Needed to avoid having the validation message from beforeunload too if there was a change and the user discards it
      changeMade = false;
    }
  }

  return proceed;
}

function setCookie(name, value, expirationMinutes) {
  var expires = "";
  if (expirationMinutes) {
      var date = new Date();
      date.setTime(date.getTime() + (expirationMinutes * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
  }
  // Set SameSite=None and Secure for cross-origin iframe
  document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=None; Secure";
}

function initRichTextEditors() {
  let containers = document.querySelectorAll('.rich-text-container');
  Array.from(containers).forEach(function (container) {
    editors[container.id] = initQuillEditorFromContainer(container);

    let originalValue = container.getAttribute('data-original-value');

    if (originalValue) {
      editors[container.id].setContents(JSON.parse(originalValue));
      $('#' + container.id + '_hidden_form_input').val(editors[container.id].root.innerHTML);
    }

    editors[container.id].on('text-change', function (delta, oldDelta, source) {
      if (source === 'user') { // Only mark as dirty if changes are made by the user
        changeMade = true;
      }
    });
  });
}

function tableRowStyleFunction(row, index) {
  if (index % 2 !== 0) {
    return {
      css: {'background-color': '#eaeaea'}
    };
  }
  else {
    return {
      css: {}
    };
  }
}